<template>
  <a-modal
      width="large"
      :visible="visible"
      :dialog-style="{ top: '0', bottom: '0' }"
      :body-style="{padding: '0', minHeight: '300px'}"
      :confirm-loading="confirmLoading"
      :footer="null"
      @cancel="visible=false"
  >
    <div slot="title">
      <b>图库</b>
      <a-divider type="vertical" />
      <a-input-search
        placeholder="搜索文件"
        style="width: 200px"
        allow-clear
        v-model="searchKeywords"
        :loading="searchLoading"
        @search="searchFiles"/>
      <span>请注意区分中英文的括号, 如不确定可不写括号, 并且用空格隔开. 如 XZS 55</span>
      <a-divider type="vertical" />
      <a-button type="primary" @click="pickLocal">自上传</a-button>
    </div>
    <a-layout>
      <a-layout-sider theme="light">
        <a-tree ref="dirTree" :load-data="onLoadTree" :tree-data="dirTree"
          :replaceFields="{title: 'name', key: 'path'}"
          :expandedKeys.sync="expandedDirs"
          :selectedKeys.sync="selectedDirs"
          @select="selectDir"
          @load="onDirLoaded"
        >
          <template></template>
        </a-tree>
      </a-layout-sider>
      <a-layout-content :style="{padding:'10px'}">
        <a-list class="gallery-images"
          :grid="{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 6, xxl: 6 }"
          :data-source="pictures"
        >
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a-card
              hoverable
              :bordered="false"
              :bodyStyle="{padding:'10px 8px', textAlign: 'center'}"
              @click="choose(item, index)"
            >
              <a-card-meta :title="item.name"></a-card-meta>
              <img
                slot="cover"
                :alt="item.name"
                :src="item.small"
              />
            </a-card>
          </a-list-item>
        </a-list>
      </a-layout-content>
    </a-layout>
  </a-modal>
</template>

<script>
import galleryModel from '@/api/gallery'
import { Modal } from 'ant-design-vue'
export default {
  components: {

  },
  data () {
    return {
      visible: false,
      confirmLoading: false,
      dirTree: [],
      pictures: [],
      expandedDirs: [],
      selectedDirs: [],
      searchKeywords: '',
      searchLoading: false
    }
  },
  created () {
    this.update()
  },
  methods: {
    update () {
      const self = this
      galleryModel.tree('./').then(res => {
        self.dirTree = res.data.filter(x => x.isDir)
      })
    },
    // 动态加载目录
    onLoadTree (treeNode) {
      const self = this
      return new Promise(resolve => {
        if (treeNode.dataRef.children) {
          resolve()
          return
        }
        galleryModel.tree(treeNode.dataRef.path).then(res => {
          treeNode.dataRef.children = res.data.filter(x => x.isDir)
          treeNode.dataRef.files = res.data.filter(x => !x.isDir)
          self.dirTree = [...self.dirTree]
          resolve()
        })
      })
    },
    selectDir (keys, e) {
      // 展开节点
      this.expandedDirs = this.expandedDirs.concat(
        keys.filter(x => !this.expandedDirs.find(y => x === y))
      )
      this.displayFilesUnderDir(e.node)
    },
    // 显示文件
    displayFilesUnderDir (node) {
      if (node.dataRef.files) {
        this.pictures = node.dataRef.files.map(x => {
          return {
            name: x.name,
            path: x.path,
            small: process.env.IMAGE_HOST + '/' + encodeURI(x.small),
            image: process.env.IMAGE_HOST + '/' + encodeURI(x.path)
          }
        })
      } else {
        this.pictures = []
      }
    },
    // 搜索文件
    searchFiles () {
      if (!this.searchKeywords) {
        return
      }
      const self = this
      self.searchLoading = true
      galleryModel.search(this.searchKeywords).then(res => {
        self.searchLoading = false
        if (res && res.data) {
          self.pictures = res.data.map(x => {
            return {
              name: x.name,
              path: x.path,
              small: process.env.IMAGE_HOST + '/' + encodeURI(x.small),
              image: process.env.IMAGE_HOST + '/' + encodeURI(x.path)
            }
          })
        } else {
          self.pictures = []
        }
      }, _ => { self.searchLoading = false })
    },
    onDirLoaded (loadedKeys, e) {
      this.selectedDirs = [e.node.eventKey]
      this.displayFilesUnderDir(e.node)
    },
    // 选择图片
    choose (item, index) {
      this.$emit('choosePicture', item)
      this.hide()
    },
    // 选择本地图片上传
    pickLocal () {
      const self = this
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.jpg,.jpeg'
      input.addEventListener('change', function (e) {
        // 上传图片,转码
        const file = e.target.files[0]
        // console.log(file)

        // 解析图片的分辨率
        let image = new Image()
        image.onload = async function () {
          console.log('dimensions', image.width, image.height)
          self.hideExtractLoading()
          if (image.width < 2000 || image.height < 2000) {
            self.$error({
              title: '不支持的图片',
              content: '图片分辨率过低 (宽高均不能低于 2000). 请重新选择高清的图片'
            })
            return
          }
          // 开始上传图片
          self.$confirm({
            title: '正在上传',
            content: '转码过程可能需要 3~5分钟. 请不要离开本页面',
            keyboard: false,
            icon: 'loading',
            okButtonProps: {
              props: { disabled: true }
            },
            cancelButtonProps: {
              props: { disabled: true }
            }
          })
          try {
            const res = await galleryModel.upload(file)
            const item = {
              name: res.data.name,
              path: res.data.path,
              small: process.env.IMAGE_HOST + '/' + encodeURI(res.data.small),
              image: process.env.IMAGE_HOST + '/' + encodeURI(res.data.path)
            }
            self.choose(item, null)
          } finally {
            Modal.destroyAll()
          }
        }
        image.onerror = function () {
          console.log(image.error)
          self.hideExtractLoading()
          self.$message.error('解析图片出错', 5)
        }

        let reader = new FileReader()
        reader.onload = function () {
          image.src = reader.result
        }
        reader.onerror = function () {
          console.log(reader.error)
          self.hideExtractLoading()
          self.$message.error('解析图片出错', 5)
        }

        self.hideExtractLoading = self.$message.loading('正在解析图片', 0)
        reader.readAsDataURL(file)
      })
      input.click()
    },
    // 窗口
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    }
  }
}
</script>

<style>
.gallery-images .ant-card-cover{height: 200px;overflow: hidden;vertical-align: middle;}
</style>



// WEBPACK FOOTER //
// src/pages/design/PickPicture.vue